import React, { useEffect } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { ModulesSection } from './components/ModulesSection';
import { LookInside } from './components/LookInside';
import { BonusSection } from './components/BonusSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
const PIXEL_ID = '1568717437983987';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      const metaWindow = window as Window & {
        fbq?: PixelFunction;
        _fbq?: PixelFunction;
      };
      if (!metaWindow.fbq) {
        const pixel = ((...args: unknown[]) => {
          if (pixel.callMethod) {
            pixel.callMethod(...args);
          } else {
            pixel.queue.push(args);
          }
        }) as PixelFunction;
        pixel.queue = [];
        pixel.push = pixel;
        pixel.loaded = true;
        pixel.version = '2.0';
        metaWindow.fbq = pixel;
        metaWindow._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      metaWindow.fbq?.('init', PIXEL_ID);
      metaWindow.fbq?.('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="sudl6ejybx89">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="stue5svuat90" />
      </noscript>
      <main className="min-h-screen w-full overflow-x-hidden bg-brand-cream" data-id="element-2" data-mp="3ubzt28o7hfdl">
        <div className="mx-auto w-full max-w-3xl bg-white shadow-2xl" data-id="element-3" data-mp="d4xp3e9cy9cu">
          <UrgencyBanner data-id="element-4" data-mp="85l30vqb96bb" />
          <Hero data-id="element-5" data-mp="85bbh3pmar3i" />
          <PainSection data-id="element-6" data-mp="86w6svjrae2f" />
          <ModulesSection data-id="element-7" data-mp="86cld4uwd7jn" />
          <LookInside data-id="element-8" data-mp="3gle90gn0mze4" />
          <BonusSection data-id="element-9" data-mp="3gkl9o0qdzc60" />
          <PricingCard data-id="element-10" data-mp="3gm65ruscn35z" />
          <Guarantee data-id="element-11" data-mp="3gja6o34rm8fy" />
          <Testimonials data-id="element-12" data-mp="3bmbgfvo82ln1" />
          <FAQ data-id="element-13" data-mp="3bn2zk70muqwf" />
          <FinalCTA data-id="element-14" data-mp="3bnmgbkejr98v" />
          <Footer data-id="element-15" data-mp="3bo4kd37garrc" />
        </div>
      </main>
    </>;
}